import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from './router'
Vue.use(VueRouter) 

 //点击同一个路由报错兼容
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//静态路由
const router = new VueRouter({
  // mode: 'history',
  // base:  process.env.API_HOST,
  // base: '/dist/login',
  routes: routers,
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
       return { x: 0, y: 0 }
  }
}) 
// 不重定向白名单
const whiteList = ['/','/login', '/404','/screen/index','/screen/school','/screen/eindex','/screen/course','/qywx/index','/qywx/qwsq','/yuxin','/yuxin1','/menhu'] 
const loginRouter = to => {
  return {
    name: 'login',
    query: { 
      back: to.fullPath
    }
  }
}
let setDocumentTitle = function (title) { 
  document.title = title
} 
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if(isChunkLoadFailed){
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
      location.reload(); 
  }
});
let href = window.location.href;
let is = href.indexOf('kh.borebore.cn');
let iss = href.indexOf('xinxiang');
//  global before guards
router.beforeEach((to, from, next) => {   
  // to.meta && typeof to.meta.pageTitle !== undefined && setDocumentTitle(to.meta.pageTitle + '-' +is==-1&&iss!=-1?'课程之家':'课后服务')
  // TOKEN
  let token = localStorage.getItem('token'); 
  // 如果登录了
  if (token && to.path !== '/login') {
    var maxLoginTime= 7.2 * 1000 * 1000;

    // 判断用户Token 是否过期
     let lastLoginTime = localStorage.getItem('timeout') || 0;
     let isPass = (Date.now() - lastLoginTime) > maxLoginTime 
     //如果过期
     if (isPass) { 
      // 清除 最后登录时间
      localStorage.removeItem('timeout')
      // 清除 TOKEN
      localStorage.removeItem('token')
      return next(loginRouter(to))
    } else { 
        next();
      }
  } else {
    // 用户没登录，跳转到登录页面
    if (whiteList.indexOf(to.path) !== -1) { // 无需拦截该路由 
      next()
    } else {
      next('/login')
    }
  }
})
 























export default router



// WEBPACK FOOTER //
// ./src/router/index.js